import { render, staticRenderFns } from "./TabelReferal.vue?vue&type=template&id=65253701&scoped=true"
import script from "./TabelReferal.vue?vue&type=script&lang=js"
export * from "./TabelReferal.vue?vue&type=script&lang=js"
import style0 from "./TabelReferal.vue?vue&type=style&index=0&id=65253701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65253701",
  null
  
)

export default component.exports